import { render, staticRenderFns } from "./Auth0Register.vue?vue&type=template&id=6f69c724&scoped=true&"
import script from "./Auth0Register.vue?vue&type=script&lang=js&"
export * from "./Auth0Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69c724",
  null
  
)

export default component.exports